// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Attestation
*/
export class TCQpSignatureModelAttestation {
    /**
    * @description Attestation Attribute Code
    */
    'attestationAttributeCode': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelAttestation>> = [
        {
            "name":     "attestationAttributeCode",
            "baseName": "attestationAttributeCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelAttestation.attributeTypeMap;
    }
}
